export default {
  async openEditModal({
    commit,
    dispatch,
  }, menuItemId) {
    dispatch('setIsShown', true);
    commit('SET_EDIT_ID', menuItemId);

    await dispatch('getPagesList', menuItemId);
  },

  closeEditModal({
    commit,
    dispatch,
  }) {
    dispatch('setIsShown', false);
    commit('RESET_EDITOR_STATE');
  },

  getPagesList({
    rootGetters,
    commit,
    state,
  }, menuItemId) {
    return rootGetters['menuGeneral/getRepository'].list()
      .then((response) => {
        commit('SET_MENU_LIST', response);

        const page = state.menuList.find((obj) => obj.menuItemId === menuItemId) || null;

        commit('SET_IS_PAGE_EDITABLE', page);

        commit('SET_PARENT_SIDEBAR_ITEMS');
      });
  },

  updateIsMenuField({
    commit,
  }, payload) {
    commit('UPDATE_IS_MENU_FIELD', payload);
  },

  updateTranslation({
    commit,
  }, payload) {
    commit('UPDATE_TRANSLATION', payload);
  },
  async update({
    state,
    rootGetters,
    dispatch,
  }) {
    const repository = rootGetters['menuGeneral/getRepository'];
    const editable = state.isMenuEditable || {};
    const customRecordId = editable.panelId ? editable.mainId : null;
    const sourceTranslations = editable.translations || {};
    const translations = Object.keys(sourceTranslations).reduce((accumulator, locale) => {
      const translation = sourceTranslations[locale] || {};

      accumulator[locale] = { name: translation.name || '' };

      return accumulator;
    }, {});
    const payload = {
      translations,
      ...editable,
    };

    if (customRecordId) {
      await repository.updateCustom(customRecordId, payload);
    } else {
      await repository.create(payload);
    }

    await dispatch('menuGeneral/table/fetch', null, { root: true });
  },
  setIsShown({ commit }, value) {
    commit('SET_IS_SHOWN', Boolean(value));
  },
};
